import css from './RadialProgress.module.scss';

interface IRadialProgressProps {
  backgroundColor?: string;
  color?: string;
  fontSize?: number;
  percentage: number;
  size: number;
  strokeWidth: number;
}

export const RadialProgress = ({
  backgroundColor = '#edf3fd', // $selago
  color = '#4a85ea', // $cornflower-blue
  fontSize = 14,
  percentage,
  size,
  strokeWidth,
}: IRadialProgressProps) => {
  const viewBox = `0 0 ${size} ${size}`;
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * Math.PI * 2;
  const dash = (percentage * circumference) / 100;

  return (
    <div className={css.container}>
      <svg width={size} height={size} viewBox={viewBox}>
        <circle
          cx={size / 2}
          cy={size / 2}
          fill="none"
          r={radius}
          stroke={backgroundColor}
          strokeWidth={`${strokeWidth}px`}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          fill="none"
          r={radius}
          stroke={color}
          // @ts-ignore
          strokeDasharray={[dash, circumference - dash]}
          strokeLinecap="butt"
          strokeWidth={`${strokeWidth}px`}
          style={{ transition: 'all 0.5s' }}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <p className={css.text} style={{ fontSize }}>
        {percentage}%
      </p>
    </div>
  );
};
